import { DotLoader } from "react-spinners";

//Loading spinner component
const Spinner = () => {
    return <DotLoader color="#50b3e0" size={40} />;
};

export default Spinner;